import apiConfig from '@constants/apiConfig';
import { commonMessage } from '@locales/intl';

import AddressSavePage from './address/AddressSavePage';
import UserSavePage from './users/UserSavePage';
import AddressListPage from './address';
import UserListPage from './users';
import UserAdminListPage from '.';
const paths = {
    adminsListPage: '/admins',
    adminsLeaderListPage: '/admins-leader',
    userListPage: '/user',
    userSavePage: '/user/:id',
    addressListPage: '/user/address',
    addressSavePage: '/user/address/:id',
};
export default {
    adminsListPage: {
        path: paths.adminsListPage,
        auth: true,
        component: UserAdminListPage,
        permission: [ apiConfig.account.getList.baseURL ],
        pageOptions: {
            objectName: commonMessage.admins,
            renderBreadcrumbs: (messages, t, title, options = {}) => {
                return [ { breadcrumbName: t.formatMessage(messages.userAdmin) } ];
            },
        },
    },
    ///LEADER

    adminsLeaderListPage: {
        path: paths.adminsLeaderListPage,
        auth: true,
        component: UserAdminListPage,
        //permission: [apiConfig.user.getList.baseURL],
        pageOptions: {
            objectName: commonMessage.adminsLeader,
            renderBreadcrumbs: (messages, t, title, options = {}) => {
                return [ { breadcrumbName: t.formatMessage(messages.userAdminLeader) } ];
            },
        },
    },
    /// USERS

    userListPage: {
        path: paths.userListPage,
        auth: true,
        component: UserListPage,
        //permission: [apiConfig.user.getList.baseURL],
        pageOptions: {
            objectName: commonMessage.user,
            renderBreadcrumbs: (messages, t, title, options = {}) => {
                return [ { breadcrumbName: t.formatMessage(messages.user) } ];
            },
        },
    },
    userSavePage: {
        path: paths.userSavePage,
        component: UserSavePage,
        separateCheck: true,
        auth: true,
        //permission: [apiConfig.user.create.baseURL, apiConfig.user.update.baseURL],
        pageOptions: {
            objectName: commonMessage.user,
            listPageUrl: paths.userListPage,
            renderBreadcrumbs: (messages, t, title, options = {}) => {
                return [
                    { breadcrumbName: t.formatMessage(messages.user), path: paths.userListPage },
                    { breadcrumbName: title },
                ];
            },
        },
    },
    addressListPage: {
        path: paths.addressListPage,
        auth: true,
        component: AddressListPage,
        //permission: [apiConfig.address.getList.baseURL],
        pageOptions: {
            objectName: commonMessage.address,
            renderBreadcrumbs: (messages, t, title, options = {}) => {
                return [
                    { breadcrumbName: t.formatMessage(messages.user), path: paths.userListPage },
                    { breadcrumbName: t.formatMessage(messages.address) },
                ];
            },
        },
    },
    addressSavePage: {
        path: paths.addressSavePage,
        component: AddressSavePage,
        separateCheck: true,
        auth: true,
        //permission: [apiConfig.address.create.baseURL, apiConfig.address.update.baseURL],
        pageOptions: {
            objectName: commonMessage.address,
            listPageUrl: paths.addressListPage,
            renderBreadcrumbs: (messages, t, title, options = {}) => {
                return [
                    { breadcrumbName: t.formatMessage(messages.user), path: paths.userListPage },
                    {
                        breadcrumbName: t.formatMessage(commonMessage.address),
                        path: paths.addressListPage + `?userId=${options.userId}`,
                    },
                    { breadcrumbName: title },
                ];
            },
        },
    },
};
